import React from 'react'
import shape57 from "../../assets/images/shapes/shape-57.png"
import shape58 from "../../assets/images/shapes/shape-58.png"
import shape89 from "../../assets/images/shapes/shape-89.png"
import team3 from "../../assets/images/team/team-1.jpg"
import { Link } from 'react-router-dom'
import { config } from '../pages/config'
import secureLocalStorage from 'react-secure-storage'

const InstructorCard = ({ instructor, dark = false }) => {
    return (
        <div className="col-lg-4 col-md-6 col-sm-12 team-block mb-5">
            <div className="team-block-one">
                <div className="inner-box">
                    <div className="image-box">
                        {/* <ul className="social-links clearfix">
                            <li>
                                <a href="#">
                                    <i className="bi bi-facebook" />
                                </a>
                            </li>
                            <li>
                                <a href="#">
                                    <i className="bi bi-twitter-x" />
                                </a>
                            </li>
                            <li>
                                <a href="#">
                                    <i className="bi bi-linkedin" />
                                </a>
                            </li>
                        </ul> */}
                        <div className="shape">
                            <div
                                className="shape-1"
                                style={{
                                    backgroundImage: `url(${shape57})`
                                }}
                            />
                            <div
                                className="shape-2"
                                style={{
                                    backgroundImage: `url(${dark ? shape89 : shape58})`
                                }}
                            />
                            <div
                                className="shape-3"
                                style={{
                                    backgroundImage: `url(${dark ? shape58 : shape89})`
                                }}
                            />
                        </div>
                        {/* <span className="text">udrive</span> */}
                        <Link to={`${config.appUrl}instructor`} onClick={() => {
                                secureLocalStorage.setItem("Instructor_Details",instructor);
                            }}>
                            <figure className="image">
                                <img src={instructor.image ? `${config.imageUrl}${instructor?.image}` : team3} alt={`${instructor.name} trainer`} />
                            </figure>
                        </Link>
                    </div>
                    <div className="lower-content">
                        <h4>
                            <Link to={`${config.appUrl}instructor`} onClick={() => {
                                secureLocalStorage.setItem("Instructor_Details",instructor);
                            }}>{instructor.name}</Link>
                        </h4>
                        <span className="designation">{instructor.address}</span>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default InstructorCard